import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface DashboardResponse {
  generatedAt: string;
  pendingApprovals: { count: number };
  topProjects: Array<{
    id: number;
    name: string;
    subdomain: string | null;
    last24h: number;
    sparkline: number[];
    days: string[];
  }>;
  attention: Array<{
    type: "tracker_silent" | "custom_hostname_pending";
    projectId: number;
    projectName: string;
    detail: string;
  }>;
}

export function useDashboard() {
  return useQuery<DashboardResponse>({
    queryKey: ["admin", "dashboard"],
    queryFn: () => api<DashboardResponse>("/admin/dashboard"),
    staleTime: 60_000,
  });
}

export interface ServiceHealthResponse {
  status: "ok" | "degraded";
  workerOk: boolean;
  services: Array<{
    service: string;
    lastHeartbeat: string;
    ageMs: number;
    status: "ok" | "stale";
    metadata: Record<string, unknown>;
  }>;
  bqSyncFailures24h: {
    total: number;
    perProject: Array<{
      projectId: number;
      count: number;
      latest: string | null;
    }>;
  };
}

export function useServiceHealth() {
  return useQuery<ServiceHealthResponse>({
    queryKey: ["admin", "service-health"],
    queryFn: () => api<ServiceHealthResponse>("/admin/service-health"),
    // Refresh every 60s so the badge becomes red within a minute of a dead
    // worker. Background tabs pause via document.hidden.
    refetchInterval: () =>
      typeof document !== "undefined" && document.hidden ? false : 60_000,
    refetchIntervalInBackground: false,
    staleTime: 30_000,
  });
}
